import * as m from "@paraglide/messages"
import type { SupportedLocale } from "@playbrain/content-types"
import { Link } from "@tanstack/react-router"
import { playdataFooterItems } from "./playdata-nav"

const footerLabel = {
  privacy: (locale: SupportedLocale) => m.playdata_nav_privacy({}, { locale }),
  terms: (locale: SupportedLocale) => m.playdata_nav_terms({}, { locale }),
}

/** The live footer: dark, centred, two underlined links, then the credit line. */
export function PlaydataFooter({ locale }: { locale: SupportedLocale }) {
  return (
    <footer className="flex flex-col items-center gap-[2.8rem] bg-play-black px-[2.4rem] py-[4rem] text-center text-play-white">
      <nav
        aria-label={m.playdata_footer_navLabel({}, { locale })}
        className="flex items-center gap-[0.8rem] text-[1.3rem]"
      >
        {playdataFooterItems.map((item, index) => (
          <span
            className="inline-flex items-center gap-[0.8rem]"
            key={item.key}
          >
            {index > 0 ? <span aria-hidden="true">|</span> : null}
            <Link
              className="underline underline-offset-2 hover:text-[var(--color-playdata-blue)]"
              params={{ locale }}
              to={item.to}
            >
              {footerLabel[item.key](locale)}
            </Link>
          </span>
        ))}
      </nav>
      <p className="text-[1.2rem]">
        {m.playdata_footer_madeWithPrefix({}, { locale })} <span aria-hidden="true">🎮</span>{" "}
        <a
          className="hover:underline"
          href="https://playbrain.com"
          rel="noopener"
        >
          {m.playdata_footer_madeWithSuffix({}, { locale })}
        </a>
      </p>
    </footer>
  )
}

export default PlaydataFooter
